<script setup lang="ts">
import {computed} from 'vue';
import useMobile from '@/composables/useMobileDependable';

const {isDesktop} = useMobile()
type Col = 'auto' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';
interface Props {
    col?: Col;
    colDesktop?: Col | undefined;
    narrow?: boolean;
    inlineContent?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    col: 'auto',
    narrow: false,
    inlineContent: false,
});

const cssClass = computed(() => {
    const classes = [colClass.value];

    if (props.narrow) {
        classes.push('is-narrow');
    }

    if (props.inlineContent) {
        classes.push('stf-col--inline-content');
    }

    return classes.join(' ');
})

const colClass = computed(() => {
    if (isDesktop.value && props.colDesktop) {
        if (props.colDesktop !== 'auto') {
            return `is-${props.colDesktop}`;
        }

        return '';
    }

    if (props.col == 'auto') {
        return '';
    }

    return `is-${props.col}`;
})

</script>

<template>
    <div class="column" :class="cssClass">
        <slot />
    </div>
</template>

<style scoped lang="scss">
.stf-col--flex {
  display: flex;
}

.stf-col--inline-content {
  display: inline-flex;
}
</style>
